<template>
    <div class="my-preview">
        <div id="preview" ref="previewElement">

            <Activityindicator v-if="isInitializing" :message='"Loading preview... Please wait."' />

            <div class="caller-name">{{ userName }}</div>
            <div class="mute-buttons">
                <button class="btn btn-info mr-2" id="mute-unmute-audio-button" @click="MuteAudio()">

                    <vue-feather v-if="isAudioMuted" type="mic-off" size="18"></vue-feather>
                    <vue-feather v-if="!isAudioMuted" type="mic" size="18"></vue-feather>
                </button>
                <button class="btn btn-primary mr-2" id="mute-unmute-video-button" @click="MuteVideo()">

                    <span v-if="isVideoMuted && isOwner"><vue-feather type="video-off" size="18"></vue-feather></span>
                    <span v-else-if="isVideoMuted && !isOwner"> <vue-feather type="video-off"
                            size="18"></vue-feather></span>
                    <span v-else><vue-feather type="video" size="18"></vue-feather></span>

                </button>
                <button v-if="!isOwner" class="btn btn-danger leave-button" title="Leave Group"
                    @click="onLeaveRoom($event)">
                    <vue-feather type="power" size="18"></vue-feather>
                </button>

            </div>
        </div>


    </div>


    <div id="nocamera" :class="{ table: !isCameraFound, 'd-none': isCameraFound }">
        <p class="text-center text-monospace h3 font-weight-bold" style="display: table-cell; color:whitesmoke">
            No camera detected. <i class="far fa-frown"></i>
            <br />
            Please connect a camera to make video call.
        </p>
    </div>
</template>


<script>

import { ref, toRaw,watch, onMounted, getCurrentInstance } from "vue";
import { createToaster } from "@meforma/vue-toaster";
import { Activityindicator } from "../activity-indicator/activity-indicator.vue"
import { StorageService } from "@/service/crmservice/StorageService";
import VideoChatService from "@/service/crmservice/videochat.service";
import { createConfirmDialog } from "vuejs-confirm-dialog";
import SimpleDialog from "@/views/shared/SimpleDialog.vue";
import { videoChatStore } from '@/store/videochat'
import { createLocalVideoTrack } from 'twilio-video';

export default ({
    name: 'camera',
    components: {
        Activityindicator
    },
    props: {
        isOwner: Boolean,
        userName: String
    },
    setup(props, ctx) {

        //====================== Variable ===========================

        const toaster = createToaster({ position: "top-right" });
        const thisApp = getCurrentInstance();
        const filters = thisApp.appContext.config.globalProperties.$filters;
        const isInitializing = ref(true);
        const videoTrack = ref(null);
        const remoteVideoTrack = ref(null);
        const isCameraFound = ref(false);
        const isAudioMuted = ref(false);
        const isVideoMuted = ref(false);
        const leaveRoom = ref(false);
        const storageService = ref(new StorageService());
        const previewElement = ref(null)
        const videoStore = videoChatStore();
        const userName = ref(props.userName);


        watch(userName, (newValue) => {
            console.log("newValue",newValue)
            // this callback is invoked when myRef changes
            //userName.value = newValue;
        })

        //====================== Function ===========================

        const initializePreview = async (deviceId) => {

            await initializeDevice(deviceId);
        }

        const finalizePreview = async () => {
            try {
                if (videoTrack.value) {
                    let rawData = toRaw(videoTrack.value);
                    rawData.detach().forEach(element => element.remove());
                }
                videoTrack.value = null;
            } catch (e) {
                console.error(e);
            }
        }

        const MuteAudio = () => {
            isAudioMuted.value = !isAudioMuted.value;
            console.log("isAudioMuted.value", isAudioMuted.value);
            ctx.emit('setMuteAudio', isAudioMuted.value)
            const message = `You are ${isAudioMuted.value ? 'mute' : 'unmute'} now.`;
            toaster.success(message);
        }
        const MuteVideo = () => {
            isVideoMuted.value = !isVideoMuted.value;
            videoStore.setMuteVideo(isVideoMuted.value)
            ctx.emit('setMuteVideo', isVideoMuted.value)
            const message = `Your video is ${isVideoMuted.value ? 'off' : 'on'} now.`;
            toaster.success(message);
        }


        const onLeaveRoom = (event) => {
            const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                question: `Are you sure you want to leave the group?`,
                header: `LEAVE GROUP`,
                cancel: `Cancel`,
                confirm: `Ok`,
            });
            onConfirm(async () => {
                ctx.emit('leaveRoom', true)

            }, error => {
                toaster.error('Something went wrong');
                isLoading.value = false
            });
            reveal(() => {
                console.log("reveal")
            });
        }


        const initializeDevice = async (deviceId) => {
            try {

                isInitializing.value = true;

                await finalizePreview();

                let Data = deviceId
                    ? await createLocalVideoTrack({ deviceId })
                    : await createLocalVideoTrack();

                videoTrack.value = Data;
                const videoElement = Data.attach();

                videoElement.style.width = '100%';
                videoElement.style.height = '100%';
                videoElement.style.border = '1px solid #fff';
                previewElement.value.appendChild(videoElement);

                isCameraFound.value = true;
            } catch (e) {
                console.log("No camera found-------", e);
            }
            finally {
                isInitializing.value = false;
            }
        }

        //====================== onMounted ===========================

        onMounted(async () => {
            if (previewElement.value) {
                const selectedVideoInput = await storageService.value.get('videoInputId');
                if (selectedVideoInput) {
                    await initializeDevice(selectedVideoInput);
                } else {
                    await initializeDevice();
                }
            }
        });

        //====================== return ===========================

        return {
            isInitializing,
            videoTrack,
            remoteVideoTrack,
            isCameraFound,
            isAudioMuted,
            isVideoMuted,
            leaveRoom,
            previewElement,
            finalizePreview,
            initializePreview,
            filters,
            thisApp,
            toaster,
            userName,
            MuteAudio,
            MuteVideo,
            onLeaveRoom,
            initializeDevice
        }
    },
})
</script>


<style scoped>
:host,
#preview,
video {
    width: 100% !important;
    height: 100% !important;
}

#mutevideo {
    position: relative;
}

.fa.fa-video-camera1:after {
    position: absolute;
    content: "/";
    color: white;
    font-weight: bold;
    font-size: 1.5em;
    text-shadow: 3px 0px 0px rgb(0 0 0);
    line-height: 53px;
    left: 111px;
    top: 9px;
    font-family: Arial;
}

.d-none {
    display: none !important;
}

.fa.fa-video-camera2:after {
    position: absolute;
    content: "/";
    color: white;
    font-weight: bold;
    font-size: 1.5em;
    text-shadow: 3px 0px 0px rgb(0 0 0);
    line-height: 53px;
    left: 90px;
    top: 9px;
    font-family: Arial;
}

.caller-name {
    position: absolute;
    left: 11px;
    bottom: 64px;
    z-index: 100000;
    background: #2f40509e;
    padding: 10px;
    width: 194px;
    color: #fff;
}


.leave-button button {
    border-radius: 100%;
}

.my-preview {
    position: relative;
    left: 0;
    bottom: 0;
}

#preview {
    border: solid 6px rgb(34, 34, 34);
    background-color: rgb(38, 38, 38);
}

#nocamera {
    border: solid 6px rgb(34, 34, 34);
    background-color: rgb(38, 38, 38);
    min-height: 400px;
}

#nocamera {
    height: 100%;
}

#nocamera.table {
    display: table;
}

div>p {
    vertical-align: middle;
    display: table-cell;
    padding: 0 10%;
}

/* #preview {    border:none;    background-color:none; margin:0;} */
#preview .table {
    margin-bottom: 0;
}

.part-list .app-camera .table video {
    border: 1px solid #fff
}

#preview {
    position: absolute;
    width: 218px !important;
    height: 225px !important;
    border: 1px solid #a1a1a1;
    padding: 10px;
    display: block;
    top: -22px;
    z-index: 0;
    left: 50%;
    background: #ffffff;
    margin-left: -109px;
    padding-bottom: 60px;
}

.part-list {
    display: flex;
    justify-content: space-between;
}

.mute-buttons {
    position: absolute;
    bottom: 10px;
    width: 90%;
    text-align: center;
    background: #f5f6fb;
    padding: 5px;
    border-radius: 45px;
    height: 45px;
    border: 1px solid #c1c1c1;
    display: flex;
    justify-content: center;
}

.mute-buttons .btn {
    border-radius: 50% !important;
    height: 35px;
    width: 35px;
    padding: 0;
    min-width: auto;
}

.mute-buttons .btn.btn-primary {
    background: linear-gradient(to bottom right, #2d7df8 0%, #70a7f7 100%) !important;
    border: 0;
}

.mute-buttons .btn.btn-info {
    background: linear-gradient(to bottom right, #13bfa6 0%, #1fc874 100%) !important;
    border: 0;
}

.mute-buttons .btn.btn-danger {
    background: linear-gradient(to bottom right, #f82d2d 0%, #f77070 100%) !important;
    border: 0;
}
</style>
